import { IChartData } from "../../Chart/types";

export const getMinMaxValues = (score: IChartData[]) => {
  const values = score.map(item => item.visibility).filter(value => value !== null);
  return {
    maxValue: Math.max(...values.filter(value => value !== null)),
    minValue: Math.min(...values.filter(value => value !== null))
  };
};